export const INSCRITOS_RECIBIDOS = "INSCRITOS_RECIBIDOS";
export const INGRESOS_RECIBIDOS = "INGRESOS_RECIBIDOS";
export const PRODUCTOS_PURCHASES_RECIBIDOS = "PRODUCTOS_PURCHASES_RECIBIDOS";